// extracted by mini-css-extract-plugin
export default {"properties":"DQyGY","interaction":"V6yXK","interactionTitle":"AgIEm","interactionInner":"pqWnw","interactionRow":"DrTOw"};